export enum ESourceValue {
    FAQ = 'faq',
    CONTACT = ' contact'
}
